<template>
  <div class="tm-page-header">
    <el-button link type="primary" class="back-btn" @click="back">
      <i class="iconfont tm-icon-left" />返回</el-button
    >
    <slot name="head-content"></slot>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
export default {
  setup(props, { attrs }) {
    const $router = useRouter();
    const back = function () {
      if (attrs.onBack) {
        attrs.onBack();
      } else {
        $router.back(-1);
      }
    };
    return { back };
  },
};
</script>

<style lang="less" scoped>
.tm-page-header {
  height: 55px;
  background: #ffffff;
  border-radius: 3px;
  border-bottom: 10px @layoutBgColor solid;
  padding: 7px 15px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 3;
  .back-btn {
    color: #000;
    .icon-left {
      margin-right: 13px;
    }
  }
}
</style>
